<dx-scroll-view data-testid="voucher-scroll-view">
  <form #formElement (submit)="onSubmit($event)">
    <dx-form
      data-testid="form"
      id="form"
      class="cards-wide"
      [formData]="voucherData"
      [items]="formItems"
      [colCount]="2"
      [showValidationSummary]="true"
      validationGroup="formGroup"
      (onContentReady)="onFormContentReady($event)">
      <dxi-item
        [colSpan]="2"
        labelMode="static"
        dataField="requestType"
        editorType="dxSelectBox"
        cssClass="dx-widget"
        [editorOptions]="{
          items: taskVoucherTypes,
          valueExpr: 'name',
          displayExpr: 'name',
          disabled: isEditable,
          required: 'true',
          searchMode: 'contains',
          searchEnabled: true,
          onSelectionChanged: onRequestTypeSelectionChanged
        }">
        <dxo-label text="Request Type"></dxo-label>
        <dxi-validation-rule type="required" message="Request Type is required">
        </dxi-validation-rule>
      </dxi-item>
      <div *dxTemplate="let section of 'fileUploadTemplate'">
        <app-file-upload
          data-testid="voucher-file-upload"
          labelText=""
          [selectButtonText]="isEditable ? 'Browse or drop files here' : 'Browse or drop files here *'"
          (onFileRemoveEventEmitter)="onFileRemove($event)"
          (onFileUploadEventEmitter)="onFileUpload($event)">
        </app-file-upload>
      </div>
    </dx-form>
    <dx-load-panel
      data-testid="voucher-load-panel"
      container=".cards-wide"
      [position]="{ of: '.content' }"
      [visible]="isLoading"
      [showPane]="true">
    </dx-load-panel>
  </form>
</dx-scroll-view>



